module.exports = __webpack_public_path__ + "static/media/welcome3.fa6d6ab7.png";